import styled from 'styled-components';

import {
  fieldVariables,
  inputContainerSizeStyles,
  inputContainerStyles,
  inputFocus,
  InputSize,
} from '@xemplo/input-utils';
import { BodySmallRegular, Colour, Shadow } from '@xemplo/style-constants';
import { XemploInput } from '@xemplo/xemplo-input';

export const ComponentWrapper = styled.div`
  ${fieldVariables};
  --input-country-prefix-color: ${Colour.Gray[500]};
  width: var(--input-width);
`;

export const FieldWrapper = styled.div`
  ${inputContainerStyles};
  ${inputContainerSizeStyles};
  border: none;
  gap: 0;

  &.invalid {
    --input-border-color: ${Colour.Red[500]};
    ${Shadow.Error2};
  }

  &:has(input:not(:focus, .has-placeholder, .has-value), input.label-hidden) {
    padding: 20px 16px;

    &.no-padding-inline {
      padding: 20px 0px;
    }
  }

  &.no-padding-inline {
    padding-inline: 0;
  }
`;

/**
 * Custom styled XemploInput for PhoneField component.
 * It overrides some of the border styling so we can
 * combine it with the CountrySelector component and
 * have the look & feel of a single input field.
 *
 * It also handles the focus and invalid states.
 *
 * The gap override is to accommodate the country code prefix.
 * By default, the XemploInput has a gap of 8px between its elements,
 * but in this case, we want to reduce it to 4px to make it look better
 * with the prefix and since it will never leading icon, this is safe to do so.
 */
export const CustomXemploInput = styled(XemploInput)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  &:focus-within:not(.invalid) {
    ${inputFocus};
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &.invalid {
    border-left-color: ${Colour.Gray[200]};
    box-shadow: none;
  }

  &.xemplo-input-container {
    gap: 4px;

    & > label.left {
      left: 16px;
    }
  }

  > input[type='tel']:focus::placeholder {
    color: transparent;
  }
`;

export const CountryPrefix = styled.span`
  ${BodySmallRegular};
  height: 100%;
  display: flex;
  align-self: flex-end;
  color: var(--input-country-prefix-color);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &.${InputSize.Spacious} {
    align-items: flex-end;
  }

  &.${InputSize.Default} {
    margin-bottom: -8.5px;
  }

  &.${InputSize.Compact} {
    align-items: center;
  }

  &.disabled {
    --input-country-prefix-color: ${Colour.Gray[200]};
  }

  &:not(.empty-placeholder):has(~ input:not(:focus, .has-value)) {
    max-width: 0;
    opacity: 0;
    margin-left: -8px;
  }

  &:has(~ input.label-hidden) {
    &.${InputSize.Default} {
      align-items: center;
      margin-bottom: auto;
    }
  }
`;
